import { useTheme } from '@mui/material'

const EditIcon = () => {
  const theme = useTheme()

  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        style={{ transition: 'fill 0.25s ease' }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 11.5V7.125H11.5V11.5H1.5V1.5H5.875V0.25H1.5C0.809644 0.25 0.25 0.809644 0.25 1.5V11.5C0.25 12.1904 0.809644 12.75 1.5 12.75H11.5C12.1904 12.75 12.75 12.1904 12.75 11.5ZM10.9864 0.702139C10.6999 0.413387 10.3076 0.25 9.89838 0.25C9.48964 0.25 9.09779 0.413018 8.80966 0.702893L3.5791 5.93339C3.11171 6.34521 2.80531 6.95802 2.75207 7.61706L2.75004 9.62646V10.2515H5.33417C6.0431 10.2028 6.66193 9.89343 7.09848 9.38985L12.2994 4.19115C12.588 3.9026 12.7501 3.51124 12.7501 3.10317C12.7501 2.69511 12.588 2.30375 12.2994 2.0152L10.9864 0.702139ZM5.28999 9.00304C5.62388 8.9794 5.93468 8.82401 6.18425 8.53853L9.97298 4.7498L8.25155 3.02827L4.43506 6.84351C4.18184 7.06747 4.02519 7.38079 4 7.66741V9.00186L5.28999 9.00304ZM9.13558 2.14453L10.8569 3.86592L11.4155 3.30728C11.4696 3.25316 11.5 3.17974 11.5 3.10319C11.5 3.02665 11.4696 2.95323 11.4155 2.89911L10.1007 1.58431C10.0472 1.53036 9.97433 1.50002 9.89834 1.50002C9.82235 1.50002 9.74951 1.53036 9.69598 1.58431L9.13558 2.14453Z"
        fill={theme.palette.custom.darkBlue2}
      />
    </svg>
  )
}

export default EditIcon
